import "./App.css";
import { Route, Routes } from "react-router-dom";
import FpmPage from "./fpm/FpmPage";
import FpmPage2 from "./fpm/FpmPage2";
import FpmPage3 from "./fpm/FpmPage3";
import FpmPage4 from "./fpm/FpmPage4";
import FpmPage5 from "./fpm/FpmPage5";
import FpmPageFil from "./fpmFil/FpmPage";
import FpmPage2Fil from "./fpmFil/FpmPage2";
import FpmPage3Fil from "./fpmFil/FpmPage3";
import FpmPage4Fil from "./fpmFil/FpmPage4";
import FpmPage5Fil from "./fpmFil/FpmPage5";

function App() {
  return (
    <Routes>
      <Route path="/" element={<FpmPage />} />
      <Route path="/page2/En" element={<FpmPage2 />} />
      <Route path="/page3/En" element={<FpmPage3 />} />
      <Route path="/page4/En" element={<FpmPage4 />} />
      <Route path="/page5/En" element={<FpmPage5 />} />
      <Route path="/Fil" element={<FpmPageFil />} />
      <Route path="/page2/Fil" element={<FpmPage2Fil />} />
      <Route path="/page3/Fil" element={<FpmPage3Fil />} />
      <Route path="/page4/Fil" element={<FpmPage4Fil />} />
      <Route path="/page5/Fil" element={<FpmPage5Fil />} />
    </Routes>
  );
}

export default App;
